// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutPageStyles } from "@turnerBlueprint/Overrides/Pages/OnePageCheckoutPage";
import { css } from "styled-components";

// XNG-Changes
onePageCheckoutPageStyles.modal = {
    modal: {
        closeButtonProps: {
            css: css`
                display: none;
            `,
        },
        cssOverrides: {
            modalTitle: css`
                &:after {
                    content: none;
                }
            `,
        },
    },
    cancelButton: {
        sizeVariant: "small",
        typographyProps: {
            lineHeight: "13px",
        },
        css: css`
            min-width: 110px;
        `,
    },
    submitButton: {
        sizeVariant: "small",
        typographyProps: {
            lineHeight: "13px",
        },
    },
    messageText: {
        size: 15,
        css: css`
            line-height: 23px;
        `,
    },
    textGridItem: {
        css: css`
            padding: 8px 15px;
        `,
    },
};
